// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let IntakeV1Api = class IntakeV1Api {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param layoutId generated
     * @param x_tc_scopeid generated
     * @param x_tc_scopetype generated
     * @param x_program_id The program id from the list of allowed program ids
     */
    async layoutGetByProgramId(layoutId, x_tc_scopeid, x_tc_scopetype, x_program_id) {
        const _url_ = '/intake/v1/Layout/{layoutId}'
            .replace('{' + 'layoutId' + '}', encodeURIComponent(String(layoutId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'layoutId' is not null or undefined
        if (layoutId === null || layoutId === undefined) {
            throw new Error('Required parameter layoutId was null or undefined when calling layoutGetByProgramId.');
        }
        _headers_['x-tc-scopeid'] = Serializer.serialize(x_tc_scopeid, "string");
        _headers_['x-tc-scopetype'] = Serializer.serialize(x_tc_scopetype, "string");
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "number");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "object");
        }
        return response;
    }
    /**
     *
     * @param layoutId generated
     * @param x_tc_scopeid generated
     * @param x_tc_scopetype generated
     */
    async layoutSectionGet(layoutId, x_tc_scopeid, x_tc_scopetype) {
        const _url_ = '/intake/v1/LayoutSection/{layoutId}'
            .replace('{' + 'layoutId' + '}', encodeURIComponent(String(layoutId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'layoutId' is not null or undefined
        if (layoutId === null || layoutId === undefined) {
            throw new Error('Required parameter layoutId was null or undefined when calling layoutSectionGet.');
        }
        _headers_['x-tc-scopeid'] = Serializer.serialize(x_tc_scopeid, "string");
        _headers_['x-tc-scopetype'] = Serializer.serialize(x_tc_scopetype, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "object");
        }
        return response;
    }
    /**
     *
     * @param layoutId generated
     * @param x_tc_scopeid generated
     * @param x_tc_scopetype generated
     */
    async layoutSurveyGet(layoutId, x_tc_scopeid, x_tc_scopetype) {
        const _url_ = '/intake/v1/LayoutSurvey/{layoutId}'
            .replace('{' + 'layoutId' + '}', encodeURIComponent(String(layoutId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'layoutId' is not null or undefined
        if (layoutId === null || layoutId === undefined) {
            throw new Error('Required parameter layoutId was null or undefined when calling layoutSurveyGet.');
        }
        _headers_['x-tc-scopeid'] = Serializer.serialize(x_tc_scopeid, "string");
        _headers_['x-tc-scopetype'] = Serializer.serialize(x_tc_scopetype, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "object");
        }
        return response;
    }
};
IntakeV1Api = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], IntakeV1Api);
export { IntakeV1Api };
//# sourceMappingURL=intakeV1Api.js.map